<template>
  <div>
    <div ref="scrollRef" class="phantom-scroll-target">
      <slot />
    </div>
    <div ref="phantomOuterRef" class="phantom-scroll-outer">
      <div ref="phantomInnerRef" class="phantom-scroll-inner" />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue';

const scrollRef = ref(null);
const phantomOuterRef = ref(null);
const phantomInnerRef = ref(null);

let isSyncing = false;
let resizeObserver = null;
let mutationObserver = null;

const syncWidth = () => {
  if (phantomInnerRef.value && scrollRef.value) {
    phantomInnerRef.value.style.width = `${scrollRef.value.scrollWidth}px`;
  }
};

const onScrollTarget = () => {
  if (isSyncing) return;

  const outer = phantomOuterRef.value;
  const target = scrollRef.value;

  if (!outer || !target) return;

  isSyncing = true;
  outer.scrollLeft = target.scrollLeft;
  isSyncing = false;
};

const onScrollPhantom = () => {
  if (isSyncing) return;

  const target = scrollRef.value;
  const outer = phantomOuterRef.value;

  if (!target || !outer) return;

  isSyncing = true;
  target.scrollLeft = outer.scrollLeft;
  isSyncing = false;
};

onMounted(() => {
  scrollRef.value?.addEventListener('scroll', onScrollTarget);
  phantomOuterRef.value?.addEventListener('scroll', onScrollPhantom);

  resizeObserver = new ResizeObserver(syncWidth);

  if (scrollRef.value) {
    resizeObserver.observe(scrollRef.value);
  }

  mutationObserver = new MutationObserver(syncWidth);

  if (scrollRef.value) {
    mutationObserver.observe(scrollRef.value, { childList: true, subtree: true });
  }

  nextTick(syncWidth);
});

onUnmounted(() => {
  scrollRef.value?.removeEventListener('scroll', onScrollTarget);
  phantomOuterRef.value?.removeEventListener('scroll', onScrollPhantom);

  resizeObserver?.disconnect();
  resizeObserver = null;

  mutationObserver?.disconnect();
  mutationObserver = null;
});
</script>

<style scoped lang="less">
.phantom-scroll-target {
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.phantom-scroll-outer {
  overflow-x: auto;
  overflow-y: hidden;
  position: sticky;
  bottom: 0;
  z-index: 4;
}

.phantom-scroll-inner {
  height: 1px;
  pointer-events: none;
}
</style>
